import React, { useState } from 'react';

import Popup from '../Popup/Popup';
import Button from '../Button/Button';
import { ButtonType } from '../../types/enums';
import Input from '../Input/Input';

import styles from './DeletePopup.module.scss';

interface DeletePopupProps {
  title: string;
  safeWord?: string;
  onDelete: () => void;
  onCancel: () => void;
}

const DeletePopup = ({ title, onDelete, onCancel, safeWord = 'DELETE' }: DeletePopupProps) => {
  const [val, setVal] = useState('');
  const [error, setError] = useState(false);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (val === safeWord) {
      onDelete();
    } else {
      setError(true);
    }
  };

  return (
    <Popup show onHide={onCancel} title="Are you sure?">
      <div>
        <p>{title}</p>
        <form onSubmit={onSubmit}>
          <Input
            id="confirm"
            label={`Type ${safeWord} to confirm:`}
            value={val}
            setValue={setVal}
            error={error ? `Error: The field must match "${safeWord}"` : ''}
            autoComplete="off"
          />
          <div className={styles.actions}>
            <Button type={ButtonType.PRIMARY} fullWidth isSubmit>
              {safeWord}
            </Button>
            <Button type={ButtonType.GHOST} fullWidth action={onCancel}>
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </Popup>
  );
};

export default DeletePopup;
